import { __extends } from "tslib";
import { Filter3DFXAATask } from './tasks/Filter3DFXAATask';
import { Filter3DBase } from './Filter3DBase';
var FXAAFilter3D = /** @class */ (function (_super) {
    __extends(FXAAFilter3D, _super);
    /**
     * Creates a new FXAAFilter3D object
     * @param amount
     * @param stepSize The distance between samples. Set to -1 to autodetect with acceptable quality.
     */
    function FXAAFilter3D(amount, stepSize) {
        if (stepSize === void 0) { stepSize = -1; }
        var _this = _super.call(this) || this;
        _this._fxaaTask = new Filter3DFXAATask(amount, stepSize);
        _this.addTask(_this._fxaaTask);
        return _this;
    }
    Object.defineProperty(FXAAFilter3D.prototype, "amount", {
        get: function () {
            return this._fxaaTask.amount;
        },
        set: function (value) {
            this._fxaaTask.amount = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FXAAFilter3D.prototype, "stepSize", {
        get: function () {
            return this._fxaaTask.stepSize;
        },
        set: function (value) {
            this._fxaaTask.stepSize = value;
        },
        enumerable: true,
        configurable: true
    });
    return FXAAFilter3D;
}(Filter3DBase));
export { FXAAFilter3D };
